import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { filter, map } from 'lodash';
import { Stack } from 'react-bootstrap';

import { loggerCommands, toggleOptions } from '../constants';
import { ToggleButton } from 'sharedComponents/ToggleButton';
import { getsubscriptionToggleOptions, updatedLoggerCommands } from '../helpers';
import { apiCallStatus } from 'helpers/constants';
import { useDataLoggerHistory } from '../useDataLoggerHistory';

const SubscribeAndUnsubscribeComponent = ({ model, actions, asset }) => {
    const { t: translate } = useTranslation();
    const [currentActivityLoggerType, setCurrentActivityLoggerType] = useState(null);
    const [selectedByLoggerType, setSelectedByLoggerType] = useState({});
    const {
        SubscibeUnsubscribeLoggerCommands,
        triggerDataLoggerCommandsLoadingStatus,
        subscribeAndUnsubscribeCommandsLoadingStatus,
        subscribeUnsubscribeLastActivityStatus,
        subscribeUnsubscribeCurrentLastActivityStatus,
    } = model;
    const filteredSubscribeAndUnsubscribeLoggerCommands = filter(SubscibeUnsubscribeLoggerCommands, specialLoggerCommand => specialLoggerCommand?.commandType === loggerCommands.SUBSCRIBEUNANDSUBSCRIBE);

    const subscribeAndUnsubscribeSpecialLogger = (selectedCommand, loggerCommand) => {
        const [subscribeCommandId, unSubscribeCommandId] = Array.isArray(loggerCommand?.commandId) ? loggerCommand.commandId : [];
        if (selectedCommand === toggleOptions.SUBSCRIBE) {
            actions?.getDataLoggerSubscribeUnsubscribeCommands({
                assetId: asset?.id,
                loggerType: loggerCommand?.loggerType,
                commandId: subscribeCommandId,
                commandDisplayName: loggerCommand?.commandDisplayName
            });
        } else if (selectedCommand === toggleOptions.UNSUBSCRIBE) {
            actions?.getDataLoggerSubscribeUnsubscribeCommands({
                assetId: asset?.id,
                loggerType: loggerCommand?.loggerType,
                commandId: unSubscribeCommandId,
                commandDisplayName: loggerCommand?.commandDisplayName
            });
        }
    };

    const updatedSubscribeAndUnsubscribeLoggerCommands = updatedLoggerCommands(filteredSubscribeAndUnsubscribeLoggerCommands);

    const {
        isCurrentActivity,
        setIsCurrentActivity,
        dataLoggerHistoryTooltip,
        currentDataLoggerHistoryTooltip,
        selectedDataLoggerCommand,
        currentSelectedDataLoggerCommand
    } = useDataLoggerHistory(subscribeUnsubscribeLastActivityStatus, subscribeUnsubscribeCurrentLastActivityStatus);

    const handleSelection = (selectedCommand, loggerCommand) => {
        subscribeAndUnsubscribeSpecialLogger(selectedCommand, loggerCommand);
        setIsCurrentActivity(true);
        const loggerType = loggerCommand?.loggerType ?? null;
        setCurrentActivityLoggerType(loggerType);
        if (loggerType) {
            setSelectedByLoggerType(prev => ({
                ...prev,
                [loggerType]: selectedCommand
            }));
        }
    };

    return (
        map(updatedSubscribeAndUnsubscribeLoggerCommands, (loggerCommand, i) => {
            const isCurrentRowActivity = !!(
                isCurrentActivity &&
                currentActivityLoggerType &&
                loggerCommand?.loggerType &&
                currentActivityLoggerType === loggerCommand.loggerType
            );
            const currentSelectedLogger = loggerCommand?.loggerType
                ? selectedByLoggerType[loggerCommand.loggerType]
                : null;
            const currentTooltip = isCurrentRowActivity ? currentDataLoggerHistoryTooltip() : null;

            return (
                <Stack direction='horizontal' key={i}>
                    <div className='data-logger__type py-2'>{loggerCommand?.commandDisplayName}</div>
                    <div className='py-1 d-flex ms-auto'>
                        <ToggleButton
                            buttonProps={{
                                disabled: triggerDataLoggerCommandsLoadingStatus === apiCallStatus.LOADING ||
                                    subscribeAndUnsubscribeCommandsLoadingStatus === apiCallStatus.LOADING
                            }}
                            options={getsubscriptionToggleOptions(translate)}
                            onSelected={(selectedCommand) => handleSelection(selectedCommand, loggerCommand)}
                            selectedValue={currentSelectedLogger || (isCurrentRowActivity ? currentSelectedDataLoggerCommand() : selectedDataLoggerCommand(loggerCommand?.loggerType))}
                        />
                        <div className='ml-2'>
                            {isCurrentRowActivity && currentTooltip ? currentTooltip : dataLoggerHistoryTooltip(loggerCommand?.loggerType)}
                        </div>
                    </div>
                </Stack>
            );
        })
    );
};

SubscribeAndUnsubscribeComponent.propTypes = {
    model: PropTypes.object,
    actions: PropTypes.object,
    asset: PropTypes.object
};

export default SubscribeAndUnsubscribeComponent;
